import React from 'react';

/**
 * @description Flow Org. send invite component
 *
 * Display the input text-box and button used to send invites to tenants.
 */
const InviteForm = ({
    onSubmit,
    onCancel,
    onInput,
    inputValue,
    renderHelpBlock, 
    inputLabel,
    validationPattern,
}) => (
    <>        
        <form 
            onSubmit={onSubmit}
        >
            <div className="form-group">
                <label>
                    { inputLabel }
                    <span className="input-required"> *</span>
                </label>
                <input
                    maxLength="255"
                    required
                    pattern={validationPattern}
                    className="form-control admin-input"
                    type="text"
                    onChange={onInput}
                    value={inputValue || ''}
                />
                {
                    renderHelpBlock()
                }
            </div>
            <footer className="form-footer">
                <button type="button" className="btn btn-sm btn-default" onClick={() => onCancel()}>Cancel</button>
                <button type="submit" className="btn btn-sm btn-success">Send Invite</button>
            </footer>
        </form>
    </>
);

export default InviteForm;
